module.exports = __webpack_public_path__ + "static/Fisherman-Text-White-Logo-3104c9889709e45941fc0ee2eb235f09.png";